export default __webpack_public_path__ + "static/media/03_photo.57d8d674.jpg";